// ----------------------------------------------------------------------- internos
import { llamar } from "./planillaMovimientos";

/* La «Planilla diaria de cargas» (192 pestañas), a Previsión.
 *
 * El mismo puente y la misma mecánica de dos pasos que la planilla de
 * movimientos: `analizar` mira y contesta qué haría, `aplicar` manda claves y
 * el servidor relee el archivo. FlotaBot elige solo la pestaña más nueva y
 * descarta las otras 191; de esa hoja carga únicamente las secciones de
 * PREVISION — los CARGADOS son historia de Movimientos y los PENDIENTES no
 * tienen fecha. */

const NO_PUEDO = "No podés pasar.";

export async function analizarCargas(archivo, pedido = "") {
  const fd = new FormData();
  fd.append("archivo", archivo);
  // La cajita: «cargar los viajes de mañana», «qué falta del 31/8». La
  // entiende FlotaBot con reglas (planilla_pedido) — sin IA. Vacía = todo.
  if (pedido) fd.append("pedido", pedido);
  return llamar("/api/cargas/analizar", fd, NO_PUEDO);
}

export async function aplicarCargas(archivo, nuevas) {
  const fd = new FormData();
  fd.append("archivo", archivo);
  fd.append("nuevas", JSON.stringify(nuevas || []));
  return llamar("/api/cargas/aplicar", fd, NO_PUEDO);
}
